import { AuthPort } from '../ports/AuthPort';
import { IdentityRepository } from '../ports/IdentityRepository';

export class ChangePasswordUseCase {
  constructor(
    private authPort: AuthPort,
    private identityRepo: IdentityRepository
  ) {}

  async execute(newPassword: string): Promise<void> {
    const user = await this.authPort.getCurrentUser();
    if (!user) throw new Error('No active session');

    await this.authPort.changePassword(newPassword);
    await this.identityRepo.updateProfile(user.uid, { mustChangePassword: false });
  }
}
